import React from 'react';
import styles from './onboarding.module.css';

function WorkInfo({ name, company, setCompany, role, setRole, onWorkBreak, setOnWorkBreak }) {

    return (
        <>
            <div></div> {/* Empty div for centering */}
            <div className={styles.flexDiv} style={{ margin: "0 0.2rem", gap: '3rem' }}>
                <div>
                    <h1 className={styles.onboardingGreeting} style={{ margin: '0.5rem', maxWidth: '17rem' }}>
                        Nice to meet you {name}!
                    </h1>
                </div>
                <div className={styles.flexDiv} style={{ width: '100%' }}>
                    <label style={{ marginBottom: "0.4rem" }}>What's your field of work?</label>
                    <input type='text' placeholder='I work at...' value={company} className={`${styles.textInput} ${styles.skinnyInput}`}
                        onChange={e => setCompany(e.target.value)} />
                    <input type='text' placeholder='My role is...' value={role} className={`${styles.textInput} ${styles.skinnyInput}`}
                        onChange={e => setRole(e.target.value)} />
                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '1.25rem' }}>
                        <input className={styles.workBreakCheckbox} type='checkbox' id='workBreak'
                            checked={onWorkBreak} onChange={(e) => setOnWorkBreak(e.target.checked)} />
                        <label htmlFor='workBreak' style={{ fontSize: '0.9rem', color: '#ffffffbd' }}>
                            I'm on a work break
                        </label>
                    </div>
                </div>
            </div>
        </>
    )
}

export default WorkInfo;